import type { IMiniFlexTableProps } from "@similarweb/ui-components";
import { StyledMiniFlexTable } from "./styles";

const SignalsTooltipTable = (props: IMiniFlexTableProps) => {
    return (
        <StyledMiniFlexTable
            className={props.className}
            data={props.data}
            columns={props.columns}
            translations={props.translations}
        />
    );
};

export default SignalsTooltipTable;
